import * as React from "react";
import type { SVGProps } from "react";
const SvgSortIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="sort_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M469.333 149.333a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H469.333zm0 426.667a42.667 42.667 0 1 0 0 85.333H896A42.667 42.667 0 1 0 896 576H469.333zm-42.666-170.667a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 448H469.333a42.667 42.667 0 0 1-42.666-42.667zm42.666 384a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H469.333zm-234.666-704a42.667 42.667 0 0 1 30.165 12.502L371.499 204.5a42.667 42.667 0 0 1-60.331 60.331l-33.835-33.835V384A42.667 42.667 0 0 1 192 384V230.997l-33.835 33.835a42.667 42.667 0 0 1-60.33-60.33L204.5 97.834a42.667 42.667 0 0 1 30.166-12.502zm0 853.334a42.667 42.667 0 0 0 30.165-12.502L371.499 819.5a42.667 42.667 0 1 0-60.331-60.331l-33.835 33.835V640A42.667 42.667 0 1 0 192 640v153.003l-33.835-33.835a42.667 42.667 0 0 0-60.33 60.33L204.5 926.166a42.667 42.667 0 0 0 30.166 12.502z"
    />
  </svg>
);
export default SvgSortIcon;
